export enum SubjectGroup {
  Humanity = 'humanity',
  Science = 'science',
}

/**
 * Relates to the `SubjectGroup` enum
 */
export enum SubjectBunriId {
  Humanity = 1,
  Science = 2,
  All = 3,
}

export enum SubjectName {
  English = 'english',
  Japanese = 'japanese',
}

/**
 * Relates to the `SubjectName` enum
 */
export enum SubjectId {
  English = 2,
  Japanese = 1,
}

export enum SubjectStatus {
  All = 'all',
  Completed = 'completed',
  NotCompleted = 'not-completed',
}

export enum CourseQuestionType {
  EnglishTranslation = 'E01',
  EnglishExplanation = 'E02',
  EnglishReading = 'E03',
  JapaneseCritique = 'G01',
  JapaneseEssay = 'G02',
}
